import { render, staticRenderFns } from "./SupplyCard.vue?vue&type=template&id=8a265d34&"
import script from "./SupplyCard.vue?vue&type=script&lang=js&"
export * from "./SupplyCard.vue?vue&type=script&lang=js&"
import style0 from "./SupplyCard.vue?vue&type=style&index=0&id=8a265d34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports